
import React, {useState,useEffect, useRef} from 'react';
import Axios from 'axios';
import useSWR from 'swr'
import { XTextStart } from './XTextStart';
// import { CounterProvider } from './CounterContext';
import { NodeProvider } from './NodeContext';
import {useNodes} from './NodeContext'
import { Window } from '../Window/Window';
import { TextOutlineWrapper } from '../TextOutlineWrapper/TextOutlineWrapper';
import { AuthorCollection } from '../AuthorCollection/AuthorCollection';
import {ResourceTypeList} from '../ResourceTypeList/ResourceTypeList'
import {Article} from '../Article/Article'
import {ExpressionType} from '../ExpressionType/ExpressionType'
import {WorkGroup} from '../WorkGroup/WorkGroup'
import {PrintView} from '../PrintView/PrintView'
import {Codex} from '../Codex/Codex'
import { getInfo } from './getInfo';
import { getRelatedExpressions } from '../TextCompareWrapper/queries';
import { runQuery } from "../utils";

import "./XTextWrapper.css"
import { ResourceSuggestor } from '../ResourceSuggestor/ResourceSuggestor';
import { e } from 'mathjs';


export interface MyComponentProps {
  resourceid: string
  secondaryResourceId?: string
  theme?: 'default' | 'dark' | 'light'; // Add theme prop
  handleResourceChange?: any
  customClassName?: string
  sideWindowOpenWidthHeight?: 'middle' | 'min' | 'max'
  excludeList?: string[] // list of components to exclude from the window tab
}

//Consider Renaming to ResourceWrapper and moving to XText to its own folder with its own stories
export const XTextWrapper: React.FC<MyComponentProps> = ({resourceid, secondaryResourceId, theme, handleResourceChange, customClassName,sideWindowOpenWidthHeight, excludeList}) => {

  
  const [secondaryRetrievedInfo, setSecondaryRetrievedInfo] = useState<any>()
  const [retrievedInfo, setRetrievedInfo] = useState<any>()
  const [previewInfo, setPreviewInfo] = useState<any>()
  const [currentResourceid, setCurrentResourceid] = useState<string>(resourceid)
  const [currentSecondaryResourceid, setCurrentSecondaryResourceid] = useState<string>(secondaryResourceId || "")
  const [previewResourceId, setPreviousResourceId] = useState<string>("")
  const [relatedElements, setRelatedElements] = useState<any[]>([])
  const [window1, setWindow1] = useState<any>({open: true,windowLoad: "citation",position: "sideWindow",openWidthHeight: sideWindowOpenWidthHeight || "min"})
  const [window2, setWindow2] = useState<any>({open: false,windowLoad: "citation",position: "bottomWindow",openWidthHeight: "middle"})
  const [itemRelatedExpressions, setItemRelatedExpressions] = useState<any[]>([])
  const [view, setView] = useState<any>({view: "web", useCache: true})
  const [variantIndexList,setVariantIndexList] = useState<any[]>([]) // used to capture variants bubbling up from collation table and then sent down via provider to paragraph to highlight variant targets
  // below sets ids to be used in collation compare; NOTE: this a good candidate to move to context provider
  const [collationCompareExpressionIds, setCollationCompareExpressionIds] = useState<string[]>([]) 
  const [commentAnnotations, setCommentAnnotations] = useState<any[]>([])
  const [hoverFocus, setHoverFocus] = useState<any[]>([])
  const [rHistory, setRHistory] = useState([resourceid]);
  const [dictionaryWord, setDictionaryWord] = useState<string>("");

  const textWrapperRef = useRef<HTMLDivElement>(null);

  const handleUpdateCompareExpressionIds = (expressionId: string) => {
    if (!collationCompareExpressionIds.includes(expressionId)){
      setCollationCompareExpressionIds([...collationCompareExpressionIds, expressionId])
      setWindow2({...window2, open: true, windowLoad: "collationTable"})
    }
    else{
      setWindow2({...window2, open: true, windowLoad: "collationTable"})
    }
  }

  const handleChangeView = (view: any) => {
    setView(view)
  }
  const handleChangeDictInfo = (text: string) => {
      setDictionaryWord(text)
      setWindow2({...window2, open: true, windowLoad: "dictionary"})
  }
  

  const handleChangeInfo = (resourceid: string, callerId: string | undefined) => {
    const updatedHistory = [...rHistory, resourceid];
    if (updatedHistory.length > 15) {
      updatedHistory.shift(); // Remove the oldest element
    }
    setRHistory(updatedHistory);
    setCurrentResourceid(resourceid)
    
    // clear collationCompareExpressionIds when resourceid changes
    setCollationCompareExpressionIds([])
    // clear setVariantIndexList when resourceid changes
    setVariantIndexList([])

    if (handleResourceChange){
      handleResourceChange(resourceid)
    }
    
    if (!callerId){
      setWindow1({...window1, open: true, windowLoad: ""})
    }
    else if (callerId === "collationTable"){
      setWindow2({...window2, open: true, windowLoad: "collationTable"})
    }
    else if (callerId === "nodeCommunities"){
      setWindow1({...window1, open: true, windowLoad: "nodeCommunities"})
    }
  }

  const handleChangeSecondaryInfo = (resourceid: string) => {
    setCurrentSecondaryResourceid(resourceid)
  }

  const handleChangePreviewInfo = (resourceid: string, callerId: string | undefined ) => {
    setPreviousResourceId(resourceid)
    if (callerId == "refQuote"){
      setWindow2({...window2, open: true, windowLoad: "preview"})
    }
  }

  //TODO; maybe this function should be "handleChangeWindowLoad"
  const handleChangeWindow = (windowId: string, windowLoad: string, open: boolean = true) => {
    if (windowId === "window1"){
      const currentWindowWidth = window1.openWidthHeight
      setWindow1({...window1, open: open, windowLoad: windowLoad, openWidthHeight: currentWindowWidth === "min" ? "middle": currentWindowWidth})
    }
    else if (windowId === "window2"){
      const currentWindowWidth = window2.openWidthHeight
      setWindow2({...window2, open: open, windowLoad: windowLoad,openWidthHeight: currentWindowWidth === "min" ? "middle": currentWindowWidth})
    }
  }

  const handleChangeWindowSize = (windowId: string, openWidthHeight: string) => {
    if (windowId === "window1"){
      
      setWindow1({...window1, openWidthHeight: openWidthHeight})
    }
    else if (windowId === "window2"){
      setWindow2({...window2, openWidthHeight: openWidthHeight})
    }
  }
  const handleChangeWindowOpenClose = (windowId: string, openStatus: boolean) => {
    if (windowId === "window1"){
      setWindow1({...window1, open: openStatus})
    }
    else if (windowId === "window2"){
      setWindow2({...window2, open: openStatus})
    }
  }

  useEffect(() => {
    if (resourceid !== currentResourceid){
      setCurrentResourceid(resourceid)
      setCurrentSecondaryResourceid(secondaryResourceId || "")
    }
  },[resourceid])

  useEffect(() => {
    fetchData();
  }, [currentResourceid])

  useEffect(() => {
    fetchData("secondary");
  }, [currentSecondaryResourceid])
  
  useEffect(() => {
    if (previewResourceId){
      fetchPreviewData();
    }
  }, [previewResourceId])
  
  

  
  const fetchData = async (type: string = "main") => {
    const rid = type === "secondary" ? currentSecondaryResourceid : currentResourceid
    // setRetrievedInfo("loading")
    getInfo(rid).then((d: any) => {
        if (d instanceof Promise) {
          d.then((result: any) => {
            if (type === "secondary"){
              setSecondaryRetrievedInfo(result);
            }
            else{
              setRetrievedInfo(result);
            }
          })
        }
        else{
          if (type === "secondary"){
            setSecondaryRetrievedInfo(d);
          }
          else{
          setRetrievedInfo(d);
          }
        }  
      }).catch((error: any) => {
        console.log("error test", error)
      })
  };

  const fetchPreviewData = async () => {
    setPreviewInfo("loading")
    getInfo(previewResourceId).then((d: any) => {
        if (d instanceof Promise) {
          d.then((result: any) => {
            setPreviewInfo(result);
          })
        }
        else{
          
          setPreviewInfo(d);
        }  
      }).catch((error: any) => {
        console.log("error", error)
      })
  };


  const displaySwitch = () => {
    if (retrievedInfo?.resourceid === "http://scta.info/resource/person" || 
        retrievedInfo?.resourceid === "http://scta.info/resource/codex" ||
        retrievedInfo?.resourceid === "http://scta.info/resource/expressionType"){
      return (<ResourceTypeList resourceTypeId={retrievedInfo.resourceid} handleChangeInfo={handleChangeInfo}/>)
    }
    else if (retrievedInfo?.displayType === "expressionType"){
      return <ExpressionType expressionTypeId={retrievedInfo?.resourceid} handleChangeInfo={handleChangeInfo}/>
    }
    else if (retrievedInfo?.displayType === "person"){
      return <AuthorCollection authorid={retrievedInfo?.resourceid} handleChangeInfo={handleChangeInfo}/>
    }
    else if (retrievedInfo?.displayType === "codex" || retrievedInfo?.displayType === "surface" || retrievedInfo?.displayType === "canvas" || retrievedInfo?.displayType === "manifest"){
      // note manifest display does not currently work (2025-01-01) because initial query does not return an results when using manifest id
      return <Codex resourceid={retrievedInfo?.resourceid} handleChangeInfo={handleChangeInfo} codexResourceType={retrievedInfo?.displayType}/>
    }
    else if (retrievedInfo?.displayType === "workGroup"){
      return <WorkGroup workGroupId={retrievedInfo?.resourceid} handleChangeInfo={handleChangeInfo}/>
    }
    else if (retrievedInfo?.displayType === "article"){
      return <Article resourceid={retrievedInfo?.resourceid} info={retrievedInfo} handleChangeInfo={handleChangeInfo}/>
    }
    else if (retrievedInfo?.focusInfo?.structureType === "collection" && !(view.view === "print" || view.view === "epub")){
      return (
      <div>
        <h2>{retrievedInfo.focusInfo.resourceTitle} by <span className="lbp-span-link" onClick={() => {handleChangeInfo(retrievedInfo.topLevelInfo.author, undefined)}}>{retrievedInfo.topLevelInfo.authorTitle}</span></h2>
        <br/>
      <TextOutlineWrapper 
        resourceid={retrievedInfo?.focusInfo.expressionid} 
        title={retrievedInfo?.focusInfo.resourceTitle} 
        showFirstLevelChildren={true} 
        handleChangeInfo={handleChangeInfo}
        showParentLink={true}/>
      </div>)
    }
    else if (retrievedInfo?.focusInfo){
      if (view.view === "print" || view.view === "epub"){
        return <PrintView tresourceid={retrievedInfo?.focusInfo.transcriptionid} useCache={view.useCache} format={view.view}/>
      }
      else{
        return <XTextStart itemExpressionid={retrievedInfo?.itemInfo.expressionid} focusExpressionId={retrievedInfo?.focusInfo.expressionid}/>
      }
    }
    else{
      return <ResourceSuggestor searchString={currentResourceid} handleChangeInfo={handleChangeInfo}/>
      
    }
  }

  // Determine the class name based on the theme prop
  const themeClass = customClassName ? customClassName : theme === 'dark' ? 'theme-dark' : theme === 'light' ? 'theme-light' : 'default';

  return (
  <NodeProvider 
  info={retrievedInfo} 
  secondaryInfo={secondaryRetrievedInfo}
  previewInfo={previewInfo} 
  handleChangeInfo={handleChangeInfo} 
  handleChangeSecondaryInfo={handleChangeSecondaryInfo}
  handleChangePreviewInfo={handleChangePreviewInfo}
  relatedElements={relatedElements}
  setRelatedElements={setRelatedElements}
  itemRelatedExpressions={itemRelatedExpressions}
  setItemRelatedExpressions={setItemRelatedExpressions}
  variantIndexList={variantIndexList}
  textWrapperRef={textWrapperRef}
  commentAnnotations={commentAnnotations}
  setCommentAnnotations={setCommentAnnotations}
  hoverFocus={hoverFocus}
  setHoverFocus={setHoverFocus}
  handleChangeDictInfo={handleChangeDictInfo}
  >
    <>
    {/* <div>{JSON.stringify(retrievedInfo)}</div> */}
    <div className={themeClass} style={{"display": "flex"}}>
    {window1.open && 
    <div className={"lbp-side-window" + " lbp-side-" + window1.openWidthHeight}>
      <Window 
        windowLoad={window1.windowLoad} 
        windowId="window1" 
        handleChangeWindow={handleChangeWindow} 
        openWidthHeight={window1.openWidthHeight}
        handleChangeWindowSize={handleChangeWindowSize}
        handleChangeWindowOpenClose={handleChangeWindowOpenClose}
        handleChangeView={handleChangeView}
        view={view}
        handleSetVariantIndexList={setVariantIndexList}
        handleUpdateCompareExpressionIds={handleUpdateCompareExpressionIds}
        collationCompareExpressionIds={collationCompareExpressionIds}
        rHistory={rHistory}
        excludeList={excludeList}
        dictionaryWord={dictionaryWord}
        />
    </div>
    }
    {window2.open && 
    <div className={"lbp-bottom-window" + " lbp-bottom-" + window2.openWidthHeight}>
      <Window windowLoad={window2.windowLoad} 
        windowId="window2" 
        handleChangeWindow={handleChangeWindow} 
        openWidthHeight={window2.openWidthHeight}
        handleChangeWindowSize={handleChangeWindowSize}
        handleChangeWindowOpenClose={handleChangeWindowOpenClose}
        handleChangeView={handleChangeView}
        view={view}
        handleSetVariantIndexList={setVariantIndexList}
        handleUpdateCompareExpressionIds={handleUpdateCompareExpressionIds}
        collationCompareExpressionIds={collationCompareExpressionIds}
        rHistory={rHistory}
        dictionaryWord={dictionaryWord}
        />
    </div>
    }
    <div className="textWrapper" ref={textWrapperRef}>
      <div className="textWrapper-inner-wrapper">
        {displaySwitch()}
      </div>
    </div>
    </div>
    </>
  </NodeProvider>
  )
}